var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('div',{staticClass:"nav-desketop"},[_c('main-menu',{attrs:{"main-menu":_vm.mainMenuItems}})],1),_c('mobile-nav',{attrs:{"listItems":[..._vm.mainMenuItems]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }